<i18n lang="yaml">
en:
  edit: Edit
  name: Name
  delete_account: Delete account
  delete_account_confirmation: Are you sure you want to delete your account? This action is irreversible and will revoke access from all servers!
  delete_account_card_body: 'Warning: this action is irreversible and will revoke access from all servers!'
  language: Language
  ru: Russian
  en: English
ru:
  edit: Редактировать
  name: Имя
  common: Общее
  delete: Удалить
  delete_account: Удалить аккаунт
  delete_account_confirmation: Вы уверены, что хотите удалить свой аккаунт? Это действие невозможно отменить; доступ ко всем серверам будет отозван!
  delete_account_card_body: 'Вы потеряете доступ ко всем организациям и ресурсам, которыми они управляют.'
  language: Язык
  ru: Русский
  en: Английский
</i18n>

<script setup lang="ts">
import { i18n } from '@/main'
import { useMyFetch } from '@/utils'
import { useAllStores } from '@/store'
import { handleError } from '@/utils/errors'
import router from '@/router'

const { authStore, alertStore, t } = useAllStores()

async function onDelete() {
  if (confirm(t('delete_account_confirmation'))) {
    const { error } = await useMyFetch('profile').delete()
    await handleError(error, router, authStore, alertStore)
    await authStore.logout()
    await router.push({ name: 'account:login' })
  }
}
</script>

<template>
  <div class="card">
    <h4 class="card-header">{{ t('language') }}</h4>
    <div class="card-body">
      <label for="locale" class="form-label">{{ t('language') }}</label>
      <select v-model="i18n.global.locale.value" class="form-select">
        <option v-for="locale in i18n.global.availableLocales" :key="locale" :value="locale">
          {{ t(locale) }}
        </option>
      </select>
    </div>
  </div>
  <div class="card mt-3 border border-danger">
    <h4 class="card-header text-danger">{{ t('delete_account') }}</h4>
    <div class="card-body">
      <p>{{ t('delete_account_card_body') }}</p>
      <button @click="onDelete" class="btn btn-danger">{{ t('delete') }}</button>
    </div>
  </div>
</template>
